<main id="main-content" class="h-screen flex flex-col pl-10 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    {{ displayTitle }}
                </h1>
                <div data-popover-target="popover-bottom" data-popover-placement="bottom" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-bottom" role="tooltip"
                    class="absolute z-30 invisible inline-block w-fit max-w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                    <div class="px-3 py-2">
                        <p>
                            {{ helpText }} Click the map button next to each field to open the nSide map tool in a
                            new tab and locate the area.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
            <eop-assistant [sectionId]="eopSectionTypeId"></eop-assistant>
        </div>
    </div>

    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-col flex-grow items-start overflow-y-auto">
        <form #areasForm="ngForm" (ngSubmit)="onSubmit()"
            class="w-full bg-white rounded-md shadow-custom-2 p-6 flex flex-col gap-4 overflow-y-auto">
            <div class="w-full flex flex-col gap-4">
                <div *ngFor="let field of areaFields" class="w-full flex flex-col gap-1">
                    <label [for]="field.key" class="oswald-font text-base">{{ field.label }}</label>
                    <div class="w-full flex flex-row items-stretch gap-2">
                        <input
                            type="text"
                            [id]="field.key"
                            [name]="field.key"
                            [(ngModel)]="areasDoc[field.key]"
                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block w-full p-2"
                            placeholder="Enter location"
                            [disabled]="!canSave()"
                        />
                        <a
                            [href]="mapUrl"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="px-3 flex items-center justify-center rounded-md border border-nside-orange-100 bg-gradient-to-b from-nside-orange-300 to-nside-orange-400 text-white hover:from-nside-orange-100 hover:to-nside-orange-200"
                            title="Open Maps in a new tab"
                        >
                            <lucide-icon [name]="icons.MapPin" [size]="20"></lucide-icon>
                        </a>
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-row gap-2 items-center justify-end">
                <button
                    *ngIf="canSave()"
                    class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                    [ngClass]="{
                        'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !isFormValid(),
                        'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': isFormValid()
                    }"
                    [disabled]="!isFormValid()"
                    (click)="$event.preventDefault(); onSubmit();"
                >
                    Save
                </button>
            </div>
        </form>
    </div>

    <!-- APPROVE DOCUMENT BUTTON -->
    <div class="p-2 w-full">
        <div class="w-full bg-white rounded-md shadow-custom-2 p-6 flex gap-4 overflow-y-auto">
            <div
                class="w-full p-2 border-l-4 bg-gray-50 rounded-r-md flex items-end gap-2"
                [ngClass]="{
                    'border-green-600': areasDoc.user_name_approved,
                    'border-nside-gray-300': !areasDoc.user_name_approved
                }"
            >
                <div class="w-full flex flex-col items-start justify-between">
                    <p class="oswald-font font-normal">
                        Confirmed By: <span class="raleway-font">{{ areasDoc.user_name_approved || 'Not Confirmed Yet' }}</span>
                    </p>
                    <p class="oswald-font font-normal">
                        Date Confirm: <span class="raleway-font">{{ areasDoc.date_approved | date: 'MM/dd/yyyy - HH:mm' }}</span>
                    </p>
                    <p *ngIf="canSave()" class="w-full text-end">
                        By clicking this button, I certify that this information is correct and does not need to be updated.
                    </p>
                </div>
                <button
                    *ngIf="canSave()"
                    class="w-20 flex items-center justify-center text-white oswald-font px-4 py-1.5 bg-gradient-to-b rounded-md"
                    [ngClass]="{
                        'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': !isFormValid(),
                        'border-green-600 from-green-500 to-green-600 hover:from-green-500 hover:to-green-700': isFormValid()
                    }"
                    [disabled]="!isFormValid()"
                    (click)="$event.preventDefault(); handleApproval();"
                >
                    Confirm
                </button>
            </div>
        </div>
    </div>

    <prv-next-buttons></prv-next-buttons>
</main>

<introduction></introduction>

<popup-message
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>
